import { useEffect, useMemo } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import { FaChevronRight } from "react-icons/fa";
import { MdHomeFilled } from "react-icons/md";
import { getStaticNewsById } from "../../data/staticSiteContent";

type SingleNewsProps = {
  id: string;
};

export default function SingleNewsScreen(props: SingleNewsProps) {
  const navigate = useNavigate();
  const news = useMemo(
    () => getStaticNewsById(props.id),
    [props.id]
  );

  const breadCrumbs = useMemo(() => {
    const base = [
      { title: <MdHomeFilled />, link: "/" },
      { title: "News", link: "/news" },
    ];
    if (news) {
      return [...base, { title: news.heading, link: "#" }];
    }
    return base;
  }, [news]);

  useEffect(() => {
    if (!news) {
      navigate("/news");
    }
  }, [news, navigate]);

  if (!news) {
    return null;
  }

  return (
    <div className="container mx-auto px-6 py-16">
      <Fade triggerOnce>
        <div className="flex flex-wrap items-center gap-1 mb-5 pt-14">
          {breadCrumbs.map((item, i) => {
            if (i < breadCrumbs.length - 1) {
              return (
                <span key={i} className="flex items-center gap-1">
                  <NavLink
                    to={item.link}
                    className={i === 0 ? "text-lg" : "text-sm"}
                  >
                    {item.title}
                  </NavLink>
                  <FaChevronRight fontSize="12px" />
                </span>
              );
            }
            return (
              <NavLink key={i} to={item.link} className="text-sm">
                {item.title}
              </NavLink>
            );
          })}
        </div>
        <img
          src={news.image}
          alt=""
          className="w-full h-60 md:h-96 object-cover object-center rounded-xl mb-5"
        />
        <p className="text-3xl font-bold lg:text-4xl mb-7">{news.heading}</p>
        <div
          className="blog-content"
          dangerouslySetInnerHTML={{ __html: news.description }}
        />
      </Fade>
    </div>
  );
}
